/*
 *
 * Settings constants
 *
 */

// LOAD
export const LOAD_SETTINGS = 'app/Settings/LOAD_SETTINGS';
export const LOAD_SETTINGS_SUCCESS = 'app/Settings/LOAD_SETTINGS_SUCCESS';
export const LOAD_SETTINGS_ERROR = 'app/Settings/LOAD_SETTINGS_ERROR';

export const FLUSH_STATE_SETTINGS = 'app/Settings/FLUSH_STATE_SETTINGS';
